module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAAEOSURBVEhL7dO9SoNBEIXhVa9Ce2tLQbCwsNPCTrALiK13oI2Vt2FnpaawsRAFSZHLiJW34M+7yc6yzJ4hEFPmwAPfzpn9QghJq/w3mzjCFR4xwcJRL/sVFo56mWJRnXlHF7WoWFTX6qKWFB8/j/ZqcYNDfJXzAJflWV3082ivFqPpKaVbvM4e0wP8RTtHurTlMbZxgt0yM5Z2pnRpyzHWsI6XMjM+fh7t1SL7QH75BoZlZnz8PNqrxQ/2sI8D7OAb/qKdI12suJ+eUnrC8+wx3cFftHOkixUXOEX+JtkZzhFd9PNorxbz+Ph5tFeLeSyqa3VRS4pFdeYNXbaQ/2DXyD/wJ9TlpUZ96CrLTEp/27LgJ8D76zcAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icon/ms-excel.png
// module id = 28
// module chunks = 0